import { useMemo } from "react";

import type { NullableMapping , NullableMappings } from "@hz/common/api-types/board";

import { Combobox } from "@components/combobox";

type MappingSelectorProps = {
  mondayColumnId: string;
  entityMap: { id: string; name: string }[] | null;
  handleFieldChange: (columnId: string, value: NullableMapping) => void;
  mappings: NullableMappings;
};

const MappingSelector = ({
  mondayColumnId,
  entityMap,
  handleFieldChange,
  mappings,
}: MappingSelectorProps) => {
  const selectedValue = mappings[mondayColumnId]?.id || "";

  const defaultOption = useMemo(() => {
    return entityMap?.find((option) => option.id === selectedValue) || null;
  }, [entityMap, selectedValue]);

  if (!entityMap) return null;

  return (
    <Combobox
      options={entityMap}
      defaultValue={defaultOption}
      getOptionLabel={(option) => option.name}
      placeholder="Map to field"
      clearable
      size="sm"
      onSelect={(option) => {
        if (!option) {
          handleFieldChange(mondayColumnId, null);
        } else {
          handleFieldChange(mondayColumnId, {
            id: option.id,
            name: option.name,
          });
        }
      }}
    />
  );
};

export default MappingSelector;
